import { useMemo } from 'react';
import { getCivilSearchFileDownloadUrl } from '~/api/civilsearch';
import { downloadAndTrackFile } from '~/common/trackFileDownload';
import type { CivilSearchMessage } from '~/common/types';
import Message from '~/components2/Messages/Message';
import MessageContainer from '~/components2/Messages/MessageContainer';
import { usePendingDownload } from '~/hooks/usePendingDownload';
import { useScrollTo } from '~/hooks/useScrollTo';
import store from '../../store';

interface Props {
  messages: CivilSearchMessage[];
}

export default function MessageList({ messages }: Props) {
  const { ref } = useScrollTo([messages]);
  const { pendingId, track } = usePendingDownload();

  const messageItems = useMemo(() => {
    return messages.map((m) => (
      <Message
        key={`message-item-${m.id}`}
        createdBy={m.createdBy}
        createdAt={m.createdAt}
        files={m.files}
        onDownload={(file) =>
          track(file.id, () =>
            downloadAndTrackFile(file, { source: 'chat_attachment', project_id: store.project?.id }, () =>
              getCivilSearchFileDownloadUrl('civilsearch-message-file', file.id, store.project?.id),
            ),
          )
        }
        pendingFileId={pendingId}
      >
        {m.message}
      </Message>
    ));
  }, [messages, pendingId, track]);

  return (
    <MessageContainer>
      {messageItems}
      <div ref={ref} />
    </MessageContainer>
  );
}
